import { render } from "./carimage3.vue?vue&type=template&id=912cbf22&scoped=true"
import script from "./carimage3.vue?vue&type=script&lang=js"
export * from "./carimage3.vue?vue&type=script&lang=js"

import "./carimage3.vue?vue&type=style&index=0&id=912cbf22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-912cbf22"]])

export default __exports__